import component from './SingleItemConstructor.vue'
export default component
